<template>
  <div class="globe-3d-map">
    <!-- 背景光圈图片 -->

    <div :id="chartId" class="chart-container"></div>

    <!-- 悬浮在地图上的内容卡片 -->
    <div class="floating-cards">
      <div v-for="(card, index) in actionCards" :key="index" class="action-card" :class="`card-${index + 1}`"
           :style="{ '--card-color': card.color }">
        <!-- 标题行：icon + 标题 -->
        <div class="card-header">
          <div class="card-icon">
            <img :src="card.icon" alt="" style="width: 100%; height: 100%; object-fit: contain;">
          </div>
          <div class="card-title">
            <span class="title-main">{{ card.title.split('-')[0] }}</span>
            <span class="title-sub">-{{ card.title.split('-')[1] }}</span>
          </div>
        </div>

        <!-- 内容列表 -->
        <div class="card-content-wrapper">
          <div class="card-content" :ref="`cardContent${index}`">
            <!-- 原始数据 -->
            <div v-for="(item, itemIndex) in card.items" :key="`original-${itemIndex}`" class="card-item"
                 :class="{ 'is-active': itemIndex === currentActiveIndex[index] }">
              <span v-if="item.number" class="item-number">{{ item.number }}</span>
              <span class="item-text">{{ item.text }}</span>
            </div>
            <!-- 复制的数据（用于无缝循环，只复制前3项） -->
            <div v-for="(item, itemIndex) in card.items.slice(0, 3)" :key="`duplicate-${itemIndex}`"
                 class="card-item duplicate-item"
                 :class="{ 'is-active': itemIndex === (currentActiveIndex[index] % card.items.length) }">
              <span v-if="item.number" class="item-number">{{ item.number }}</span>
              <span class="item-text">{{ item.text }}</span>
            </div>
          </div>
        </div>
        <div class="card-bg-glow" :style="{ 'background-color': card.color }"></div>
      </div>
    </div>
    <div class="globe-bg-shell"></div>

  </div>
</template>

<script>
// 需要安装 echarts-gl: npm install echarts-gl
import 'echarts-gl'
import geoJsonData from '@/utils/geoJson.json'

export default {
  name: 'Globe3DMap',
  props: {
    wdgcList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      chartId: `globe3dMap_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      myChart: null,
      baseTexture: null,
      earthImage: require('@/assets/diqiu.gif'),
      geoJson: geoJsonData,
      scrollTimers: [], // 存储每个卡片的滚动定时器
      currentActiveIndex: [0, 0, 0, 0, 0], // 存储每个卡片当前激活的项索引
      geoCoordMap: {
        "海门": [121.15, 31.89],
        "鄂尔多斯": [109.781327, 39.608266],
        "招远": [120.38, 37.35],
        "舟山": [122.207216, 29.985295],
        "齐齐哈尔": [123.97, 47.33],
        "盐城": [120.13, 33.38],
        "赤峰": [118.87, 42.28],
        "青岛": [120.33, 36.07],
        "乳山": [121.52, 36.89],
        "金昌": [102.188043, 38.520089],
        "泉州": [118.58, 24.93],
        "莱西": [120.53, 36.86],
        "日照": [119.46, 35.42],
        "胶南": [119.97, 35.88],
        "南通": [121.05, 32.08],
        "拉萨": [91.11, 29.97],
        "云浮": [112.02, 22.93],
        "梅州": [116.1, 24.55],
        "文登": [122.05, 37.2],
        "上海": [121.48, 31.22],
        "攀枝花": [101.718637, 26.582347],
        "威海": [122.1, 37.5],
        "承德": [117.93, 40.97],
        "厦门": [118.1, 24.46],
        "汕尾": [115.375279, 22.786211],
        "潮州": [116.63, 23.68],
        "丹东": [124.37, 40.13],
        "太仓": [121.1, 31.45],
        "曲靖": [103.79, 25.51],
        "烟台": [121.39, 37.52],
        "福州": [119.3, 26.08],
        "瓦房店": [121.979603, 39.627114],
        "即墨": [120.45, 36.38],
        "抚顺": [123.97, 41.97],
        "玉溪": [102.52, 24.35],
        "张家口": [114.87, 40.82],
        "阳泉": [113.57, 37.85],
        "莱州": [119.942327, 37.177017],
        "湖州": [120.1, 30.86],
        "汕头": [116.69, 23.39],
        "昆山": [120.95, 31.39],
        "宁波": [121.56, 29.86],
        "湛江": [110.359377, 21.270708],
        "揭阳": [116.35, 23.55],
        "荣成": [122.41, 37.16],
        "连云港": [119.16, 34.59],
        "葫芦岛": [120.836932, 40.711052],
        "常熟": [120.74, 31.64],
        "东莞": [113.75, 23.04],
        "河源": [114.68, 23.73],
        "淮安": [119.15, 33.5],
        "泰州": [119.9, 32.49],
        "南宁": [108.33, 22.84],
        "营口": [122.18, 40.65],
        "惠州": [114.4, 23.09],
        "江阴": [120.26, 31.91],
        "蓬莱": [120.75, 37.8],
        "韶关": [113.62, 24.84],
        "嘉峪关": [98.289152, 39.77313],
        "广州": [113.23, 23.16],
        "延安": [109.47, 36.6],
        "太原": [112.53, 37.87],
        "清远": [113.01, 23.7],
        "中山": [113.38, 22.52],
        "昆明": [102.73, 25.04],
        "寿光": [118.73, 36.86],
        "盘锦": [122.070714, 41.119997],
        "长治": [113.08, 36.18],
        "深圳": [114.07, 22.62],
        "珠海": [113.52, 22.3],
        "宿迁": [118.3, 33.96],
        "咸阳": [108.72, 34.36],
        "铜川": [109.11, 35.09],
        "平度": [119.97, 36.77],
        "佛山": [113.11, 23.05],
        "海口": [110.35, 20.02],
        "江门": [113.06, 22.61],
        "章丘": [117.53, 36.72],
        "肇庆": [112.44, 23.05],
        "大连": [121.62, 38.92],
        "临汾": [111.5, 36.08],
        "吴江": [120.63, 31.16],
        "石嘴山": [106.39, 39.04],
        "沈阳": [123.38, 41.8],
        "苏州": [120.62, 31.32],
        "茂名": [110.88, 21.68],
        "嘉兴": [120.76, 30.77],
        "长春": [125.35, 43.88],
        "胶州": [120.03336, 36.264622],
        "银川": [106.27, 38.47],
        "张家港": [120.555821, 31.875428],
        "三门峡": [111.19, 34.76],
        "锦州": [121.15, 41.13],
        "南昌": [115.89, 28.68],
        "柳州": [109.4, 24.33],
        "三亚": [109.511909, 18.252847],
        "自贡": [104.778442, 29.33903],
        "吉林": [126.57, 43.87],
        "阳江": [111.95, 21.85],
        "泸州": [105.39, 28.91],
        "西宁": [101.74, 36.56],
        "宜宾": [104.56, 29.77],
        "呼和浩特": [111.65, 40.82],
        "成都": [104.06, 30.67],
        "大同": [113.3, 40.12],
        "镇江": [119.44, 32.2],
        "桂林": [110.28, 25.29],
        "张家界": [110.479191, 29.117096],
        "宜兴": [119.82, 31.36],
        "北海": [109.12, 21.49],
        "西安": [108.95, 34.27],
        "金坛": [119.56, 31.74],
        "东营": [118.49, 37.46],
        "牡丹江": [129.58, 44.6],
        "遵义": [106.9, 27.7],
        "绍兴": [120.58, 30.01],
        "扬州": [119.42, 32.39],
        "常州": [119.95, 31.79],
        "潍坊": [119.1, 36.62],
        "重庆": [106.54, 29.59],
        "台州": [121.420757, 28.656386],
        "南京": [118.78, 32.04],
        "滨州": [118.03, 37.36],
        "贵阳": [106.71, 26.57],
        "无锡": [120.29, 31.59],
        "本溪": [123.73, 41.3],
        "克拉玛依": [84.77, 45.59],
        "渭南": [109.5, 34.52],
        "马鞍山": [118.48, 31.56],
        "宝鸡": [107.15, 34.38],
        "焦作": [113.21, 35.24],
        "句容": [119.16, 31.95],
        "北京": [116.46, 39.92],
        "徐州": [117.2, 34.26],
        "衡水": [115.72, 37.72],
        "包头": [110, 40.58],
        "绵阳": [104.73, 31.48],
        "乌鲁木齐": [87.68, 43.77],
        "枣庄": [117.57, 34.86],
        "杭州": [120.19, 30.26],
        "淄博": [118.05, 36.78],
        "鞍山": [122.85, 41.12],
        "溧阳": [119.48, 31.43],
        "库尔勒": [86.06, 41.68],
        "安阳": [114.35, 36.1],
        "开封": [114.35, 34.79],
        "济南": [117, 36.65],
        "德阳": [104.37, 31.13],
        "温州": [120.65, 28.01],
        "九江": [115.97, 29.71],
        "邯郸": [114.47, 36.6],
        "临安": [119.72, 30.23],
        "兰州": [103.73, 36.03],
        "沧州": [116.83, 38.33],
        "临沂": [118.35, 35.05],
        "南充": [106.110698, 30.837793],
        "天津": [117.2, 39.13],
        "富阳": [119.95, 30.07],
        "泰安": [117.13, 36.18],
        "诸暨": [120.23, 29.71],
        "郑州": [113.65, 34.76],
        "哈尔滨": [126.63, 45.75],
        "聊城": [115.97, 36.45],
        "芜湖": [118.38, 31.33],
        "唐山": [118.02, 39.63],
        "平顶山": [113.29, 33.75],
        "邢台": [114.48, 37.05],
        "德州": [116.29, 37.45],
        "济宁": [116.59, 35.38],
        "荆州": [112.239741, 30.335165],
        "宜昌": [111.3, 30.7],
        "义乌": [120.06, 29.32],
        "丽水": [119.92, 28.45],
        "洛阳": [112.44, 34.7],
        "秦皇岛": [119.57, 39.95],
        "株洲": [113.16, 27.83],
        "石家庄": [114.48, 38.03],
        "莱芜": [117.67, 36.19],
        "常德": [111.69, 29.05],
        "保定": [115.48, 38.85],
        "湘潭": [112.91, 27.87],
        "金华": [119.64, 29.12],
        "岳阳": [113.09, 29.37],
        "长沙": [113, 28.21],
        "衢州": [118.88, 28.97],
        "廊坊": [116.7, 39.53],
        "菏泽": [115.480656, 35.23375],
        "合肥": [117.27, 31.86],
        "武汉": [114.31, 30.52],
        "大庆": [125.03, 46.58]
      },
      alirl: [
        [[121.15, 31.89], [121.48, 31.22]],
        [[120.38, 37.35], [121.48, 31.22]],
        [[123.97, 47.33], [121.48, 31.22]],
        [[118.87, 42.28], [121.48, 31.22]],
        [[121.52, 36.89], [121.48, 31.22]],
        [[102.188043, 38.520089], [121.48, 31.22]],
        [[118.58, 24.93], [121.48, 31.22]],
        [[120.53, 36.86], [121.48, 31.22]],
        [[119.46, 35.42], [121.48, 31.22]],
        [[119.97, 35.88], [121.48, 31.22]],
        [[121.05, 32.08], [121.48, 31.22]],
        [[91.11, 29.97], [121.48, 31.22]]
      ],
      // 悬浮卡片数据
      actionCards: [
        {
          icon: require('@/assets/page2/1762003326898-JJYEHB3i.png'),
          title: '红色领航-思想引领工程',
          color: '#f83d5b',
          items: [
            {number: '1', text: '打造党工共建示范点15个'},
            {number: '2', text: '新增产业工人党员50名'},
            {number: '3', text: '开展主题宣讲50场次'},
            {number: '4', text: '每年开展职工思政品牌活动12场'},
          ]
        },
        {
          icon: require('@/assets/page2/1762008070501-mZptLZBH.png'),
          title: '链上建功-地位提升工程',
          color: '#1ef0ff',
          items: [
            {number: '1', text: '开展劳动和技能竞赛120场次'},
            {number: '2', text: '建成劳模（职工）创新工作室30个'},
            {number: '3', text: '推动实现技术攻关突破50项'},
            {number: '4', text: '推动转化创新成果30项'},
          ]
        },
        {
          icon: require('@/assets/page2/1762008288799-7Q2UGp_t.png'),
          title: '权益护航-地位提升工程',
          color: '#0acf8f',
          items: [
            {number: '1', text: '职代会、厂务公开制度覆盖率100%'},
            {number: '2', text: '劳动纠纷调解成功率不低于98%'},
            {number: '3', text: '每年举行企业安全生产培训不少于50场次'},
            {number: '4', text: '每年确保产业工人在镇党代会代表等占比不低于20%'},
          ]
        },
        {
          icon: require('@/assets/page2/1762008374835-Y3GSLOAY.png'),
          title: '队伍扩容-壮大提升工程',
          color: '#6b6fff',
          items: [
            {number: '1', text: '建成标准化职工服务站点10个以上'},
            {number: '2', text: '每年举办“产业链专场招聘会”12场'},
            {number: '3', text: '新增产业链就业不少于3000人'},
            {number: '4', text: '推动晋升技术主管100名以上'},
          ]
        },
        {
          icon: require('@/assets/page2/1762008486305-3NBE5FIQ.png'),
          title: '产教融合-素质提升工程',
          color: '#ffe70e',
          items: [
            {number: '1', text: '培养紧缺工种人才1000名以上'},
            {number: '2', text: '线上培训覆盖职工不少于1万人次'},
            {number: '3', text: '每年开展岗位技能提升培训不少于1500人次'},
            {number: '4', text: '帮助200名以上职工实现学历提升'}
          ]
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoadInfo()
      this.initChart()
      this.startAllCardsScroll()
    })
  },
  beforeDestroy() {
    this.stopAllCardsScroll()
    window.removeEventListener('resize', this.handleResize)
    if (this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
    this.baseTexture = null
  },
  methods: {
// 修复后的 onLoadInfo 方法
    onLoadInfo() {
      if (!this.wdgcList || this.wdgcList.length === 0) return;

      // 按照 name 和 desc1 对数据进行分组
      const groupedData = {};
      this.wdgcList.forEach(item => {
        // 修复：去除 name 字段前后的空格
        const key = `${item.name.trim()}-${item.desc1}`;
        if (!groupedData[key]) {
          groupedData[key] = [];
        }
        groupedData[key].push(item);
      });

      // 定义卡片标题与颜色的映射关系
      const cardConfig = {
        '红色领航-思想引领工程': {
          icon:require('@/assets/page2/1762003326898-JJYEHB3i.png'),
          color: '#f83d5b'
        },
        '链上建功-地位提升工程': {
          icon: require('@/assets/page2/1762008070501-mZptLZBH.png'),
          color: '#1ef0ff'
        },
        '权益护航-地位提升工程': {
          icon: require('@/assets/page2/1762008288799-7Q2UGp_t.png'),
          color: '#0acf8f'
        },
        '队伍扩容-壮大提升工程': {
          icon: require('@/assets/page2/1762008374835-Y3GSLOAY.png'),
          color: '#6b6fff'
        },
        '产教融合-素质提升工程': {
          icon: require('@/assets/page2/1762008486305-3NBE5FIQ.png'),
          color: '#ffe70e'
        }
      };

      // 重新构建 actionCards 数据
      const updatedActionCards = [];

      // 按照固定顺序处理卡片数据
      Object.keys(cardConfig).forEach((key) => {
        if (groupedData[key]) {
          const config = cardConfig[key];
          const items = groupedData[key].map((item, itemIndex) => ({
            number: (itemIndex + 1).toString(),
            text: item.jh
          }));

          updatedActionCards.push({
            icon: config.icon,
            title: key, // 直接使用 key 作为标题
            color: config.color,
            items: items
          });
        }
      });

      // 更新 actionCards 数据
      this.actionCards = updatedActionCards;
    },

    initChart() {
      const chartDom = document.getElementById(this.chartId)
      if (!chartDom) {
        console.error('找不到图表容器', this.chartId)
        return
      }

      // 确保容器有尺寸
      if (chartDom.offsetWidth === 0 || chartDom.offsetHeight === 0) {
        console.warn('图表容器尺寸为0，等待容器渲染')
        setTimeout(() => {
          this.initChart()
        }, 100)
        return
      }

      console.log('初始化3D地球地图，容器尺寸:', chartDom.offsetWidth, 'x', chartDom.offsetHeight)
      this.myChart = this.$echarts.init(chartDom)
      // 监听窗口大小变化
      window.addEventListener('resize', this.handleResize)
      this.getGeoJsonData()
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    convertData(data) {
      const res = []
      for (let i = 0; i < data.length; i++) {
        const geoCoord = this.geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
      return res
    },
    getGeoJsonData() {
      // 直接使用本地导入的 geoJson 数据
      if (this.geoJson) {
        this.getBaseTexture()
      } else {
        console.warn('geoJson 数据未加载，使用默认配置')
        this.getBaseTexture()
      }
    },
    getBaseTexture() {
      // 注册地图数据
      if (this.geoJson) {
        try {
          this.$echarts.registerMap('world', this.geoJson)
        } catch (error) {
          console.warn('注册地图数据失败', error)
        }
      }

      // 使用 require 来正确加载本地图片资源
      this.baseTexture = require('@/assets/earth.jpg')
      // this.baseTexture = require('@/assets/bathymetry_bw_composite_4k.jpg')
      this.drawEarth()
    },
    drawEarth() {
      const chartDom = document.getElementById(this.chartId)
      if (!chartDom) {
        console.error('图表容器不存在，无法渲染图片')
        return
      }

      // 如果之前初始化了 ECharts，先销毁释放资源
      if (this.myChart) {
        this.myChart.dispose()
        this.myChart = null
      }

      chartDom.innerHTML = ''
      const imgEl = document.createElement('img')
      imgEl.src = this.earthImage
      imgEl.alt = '地球展示'
      imgEl.className = 'earth-gif'
      chartDom.appendChild(imgEl)
    },
    rodamData() {
      const longitude = 105.18
      const longitude2 = Math.random() * 360 - 180
      const latitude = 37.51
      const latitude2 = Math.random() * 180 - 90
      return {
        coords: [
          [longitude2, latitude2],
          [longitude, latitude]
        ],
        value: (Math.random() * 3000).toFixed(2)
      }
    },
    // 启动所有卡片的滚动
    startAllCardsScroll() {
      this.actionCards.forEach((card, index) => {
        this.startCardScroll(index)
      })
    },
    // 停止所有卡片的滚动
    stopAllCardsScroll() {
      this.scrollTimers.forEach(timer => {
        if (timer) clearInterval(timer)
      })
      this.scrollTimers = []
    },
    // 启动单个卡片的滚动
    startCardScroll(index) {
      // 等待DOM渲染完成
      this.$nextTick(() => {
        const contentRef = this.$refs[`cardContent${index}`]
        if (!contentRef || !contentRef[0]) return

        const contentElement = contentRef[0]
        const items = contentElement.querySelectorAll('.card-item')

        // 如果少于或等于3个项目，不需要滚动
        if (items.length <= 3) {
          // 即使不滚动，也要设置第一个为激活状态
          this.$set(this.currentActiveIndex, index, 0)
          return
        }

        let currentItemIndex = 0
        const itemHeight = items[0].offsetHeight + 18 // 包含gap
        const originalItemsCount = this.actionCards[index].items.length // 原始数据项数量

        // 设置第一个为激活状态
        this.$set(this.currentActiveIndex, index, 0)

        // 每3秒滚动一次
        const timer = setInterval(() => {
          // 移动到下一项
          currentItemIndex++

          // 如果滚动到复制的第一项（即原始数据的最后一项之后），需要无缝重置
          if (currentItemIndex >= originalItemsCount) {
            // 滚动到复制的第一项位置（视觉上连续）
            contentElement.style.transition = 'transform 0.8s ease-in-out'
            contentElement.style.transform = `translateY(-${currentItemIndex * itemHeight}px)`

            // 在动画完成后，无缝跳转回起始位置（第一项）
            setTimeout(() => {
              currentItemIndex = 0
              contentElement.style.transition = 'none'
              contentElement.style.transform = 'translateY(0)'

              // 立即恢复过渡效果，为下次滚动做准备
              setTimeout(() => {
                contentElement.style.transition = 'transform 0.8s ease-in-out'
              }, 50)
            }, 800) // 等待动画完成（0.8s）
          } else {
            // 正常滚动
            contentElement.style.transition = 'transform 0.8s ease-in-out'
            contentElement.style.transform = `translateY(-${currentItemIndex * itemHeight}px)`
          }

          // 更新激活索引（使用模运算，确保索引在原始数据范围内）
          this.$set(this.currentActiveIndex, index, currentItemIndex % originalItemsCount)
        }, 3000)

        this.scrollTimers[index] = timer
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.globe-3d-map {
  width: 100%;
  height: 100%;
  position: relative;

  // 背景光圈图片
  .globe-bg-shell {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1.4);
    width: 600px;
    height: 600px;
    background-image: url('../../assets/1676445576146-awC5zqC3.webp');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.5;
    pointer-events: none;
    z-index: 5;
  }

  .chart-container {
    width: 100%;
    height: 100%;
    min-height: 500px;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }

  ::v-deep .earth-gif {
    width: 50%;
    height: auto;
    object-fit: contain;
    display: block;
    border-radius: 50%;
  }

  // 悬浮卡片容器
  .floating-cards {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
  }

  // 单个卡片
  .action-card {
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid var(--card-color);
    border-radius: 12px;
    padding: 20px 22px;
    min-width: 380px;
    max-width: 420px;
    pointer-events: auto;
    overflow: hidden;
    backdrop-filter: blur(5px);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: var(--card-color);
      opacity: 0.08;
      z-index: 0;
    }

    // 标题行：icon + 标题
    .card-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 18px;
      position: relative;
      z-index: 1;

      .card-icon {
        width: 50px;
        height: 50px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .card-title {
        flex: 1;
        display: flex;
        align-items: baseline;
        gap: 0;
        white-space: nowrap;
        overflow: hidden;

        .title-main {
          font-size: 28px;
          font-weight: 900;
          color: var(--card-color);
          line-height: 1.3;
          letter-spacing: 1px;
          flex-shrink: 0;
        }

        .title-sub {
          font-size: 18px;
          font-weight: 700;
          color: var(--card-color);
          line-height: 1.3;
          opacity: 0.8;
        }
      }
    }

    // 内容列表容器（固定高度，显示3行）
    .card-content-wrapper {
      height: 120px; // 固定高度，显示3行
      overflow: hidden;
      position: relative;
      z-index: 1;
    }

    // 内容列表
    .card-content {
      display: flex;
      flex-direction: column;
      gap: 18px;
      transition: transform 0.8s ease-in-out;

      .card-item {
        display: flex;
        align-items: center;
        gap: 14px;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1.5;
        height: 34px; // 固定每行高度

        .item-number {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: 700;
          color: var(--card-color);
          background: rgba(255, 255, 255, 0.15);
          border: 2px solid var(--card-color);
          border-radius: 50%;
          transition: all 0.3s ease;
        }

        .item-text {
          flex: 1;
          word-break: break-word;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: color 0.3s ease;
          font-size: 25px;
          font-weight: 700;
        }

        // 激活状态
        &.is-active {
          .item-number {
            background: transparent;
            border-color: transparent;
            color: var(--card-color);
            font-size: 20px;
            text-shadow: 0 0 10px var(--card-color);
          }

          .item-text {
            color: var(--card-color);
            font-weight: 900;
            font-size: 22px;
          }
        }
      }
    }

    // 背景发光效果
    .card-bg-glow {
      position: absolute;
      bottom: -30px;
      right: -30px;
      width: 100px;
      height: 100px;
      background: var(--card-color);
      border-radius: 50%;
      filter: blur(30px);
      opacity: 0.15;
      transition: all 0.3s ease;
      z-index: -1;
    }

    // 卡片定位（围绕地图中心分布）
    &.card-1 {
      // 左上
      top: 8%;
      left: 1%;
    }

    &.card-2 {
      // 左下
      bottom: 8%;
      left: 1%;
    }

    &.card-3 {
      // 右上
      top: 1%;
      right: 1%;
    }

    &.card-4 {
      // 右中
      top: 50%;
      right: 1%;
      transform: translateY(-50%);
    }

    &.card-5 {
      // 右下
      bottom: 2%;
      right: 1%;
    }
  }
}

// 响应式调整
@media (max-width: 1600px) {
  .globe-3d-map {
    .action-card {
      min-width: 440px;
      max-width: 580px;
      padding: 16px 18px;
      height: 240px;

      .card-header {
        margin-bottom: 14px;

        .card-icon {
          width: 42px;
          height: 42px;
        }

        .card-title {
          .title-main {
            font-size: 26px;
            font-weight: 900;
          }

          .title-sub {
            font-size: 16px;
            font-weight: 700;
          }
        }
      }


      .card-content {
        gap: 15px;

        .card-item {
          font-size: 16px;
          height: 30px;

          .item-number {
            width: 28px;
            height: 28px;
            font-size: 16px;
          }

          &.is-active .item-number {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
